import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/20/solid';
import { flexRender } from '@tanstack/react-table';

export const SortableHeader = ({ header }) => {
	const column = header.column;
	const canSort = column.getCanSort();
	const sortDir = column.getIsSorted();

	const HeaderContent = flexRender(column.columnDef.header, header.getContext());

	return (
		<div className='relative flex h-full w-full select-none items-center'>
			<button
				type='button'
				onClick={canSort ? column.getToggleSortingHandler() : undefined}
				className={`flex h-7 flex-1 items-center gap-1 truncate text-left ${canSort ? 'cursor-pointer hover:text-indigo-600' : 'cursor-default'}`}
			>
				<span className='truncate text-[11px] font-semibold uppercase tracking-wider leading-none'>
					{HeaderContent}
				</span>
				{canSort && (
					<span className='inline-flex shrink-0 flex-col -space-y-1.5 text-slate-400' aria-hidden='true'>
						<ChevronUpIcon
							className={`h-2.5 w-2.5 transition-colors ${sortDir === 'asc' ? 'text-indigo-600' : ''}`}
						/>
						<ChevronDownIcon
							className={`h-2.5 w-2.5 transition-colors ${sortDir === 'desc' ? 'text-indigo-600' : ''}`}
						/>
					</span>
				)}
			</button>
		</div>
	);
};
